/**
 * @file search-results.js
 */
import {getResultCountHtml} from "./view-helpers";

(function ($, Drupal, drupalSettings, once) {
  'use strict';

  function updateResultCountSearch() {
    // Ensure we have results first
    let pagesCurrentItem = document.querySelector('.insights-display span[data-pages-current]');
    let resultsDisplay = document.getElementById('resultCount');

    if (pagesCurrentItem && resultsDisplay) {
      const pagesCurrent = parseInt(pagesCurrentItem.textContent);
      const itemsPerPage = parseInt(document.querySelector('.insights-display span[data-items-per-page]').textContent);
      const itemsTotal = parseInt(document.querySelector('.insights-display span[data-items-total]').textContent);
      resultsDisplay.innerHTML = getResultCountHtml(pagesCurrent, itemsPerPage, itemsTotal);
    } else {
      if (resultsDisplay) {
        resultsDisplay.innerHTML = '';
      }
    }
  }

  Drupal.behaviors.kodakSearchBlock = {
    attach: function (context, settings) {

      // Add text to the search field.
      if ($('[data-drupal-selector="edit-search-api-fulltext"]').val()) {
        $('#all-search-input').val($('[data-drupal-selector="edit-search-api-fulltext"]').val());
      }

      // Attach keydown event for the search input, using `once` to avoid multiple bindings
      once('allSearchInput', $('#all-search-input', context)).forEach((element) => {
        $(element).on('keydown', function (e) {
          if (e.key === 'Enter') {
            // Prevent the default Enter key action (form submit)
            e.preventDefault();

            $('[data-drupal-selector="edit-search-api-fulltext"]').val($(this).val());

            // Trigger the AJAX form submission
            $('[data-bef-auto-submit-click]').click();
          }
        });

        // Add a click event for the submit icon button
        $('.all-search-button', context).on('click', function () {
          const searchInputValue = $('#all-search-input').val();
          $('[data-drupal-selector="edit-search-api-fulltext"]').val(searchInputValue);

          // Trigger the AJAX form submission
          $('[data-bef-auto-submit-click]').click();
        });

        // Initial update of the result count on page load
        updateResultCountSearch();

      });
    }
  };

  // Re-apply the behavior and update result count on AJAX updates.
  $(document).ajaxComplete(function () {
    if ($('#all-search-input').length) {
      // Re-attach the behavior with the document context to handle all elements.
      Drupal.behaviors.kodakSearchBlock.attach(document, drupalSettings);
      // Call updateResultCount again to update the result count after AJAX completes
      updateResultCountSearch();
    }
  });

})(jQuery, Drupal, drupalSettings, once);
